<script lang="ts" setup>
import type { Tag } from '@blog/types'

const { directusUrl } = useRuntimeConfig().public

const route = useRoute()
const selected = (route.params.tags as string)?.split(',') ?? []

const { data, error, pending: isFetching } = await useLazyFetch<{ data: Tag[] }>(`${directusUrl}/items/bitbeli_tag?fields=slug,title`)
const allTags = computed(() => data.value?.data ?? [])

function tagLink (tag: Tag) {
  const tags = selected.includes(tag.slug) ? selected.filter(t => t !== tag.slug) : [...selected, tag.slug]
  if (!tags.length)
    return '/blog'

  return `/blog/tag-${tags.join(',')}`
}
</script>

<template>
  <div v-if="!error" relative fubex-rounded-lg border border-neutral-300 py-32px px-24px max-w-400px w-full>
    <h2 heading6 font-500 text-neutral-900 border-b border-neutral-300 pb-16px mb-26px>
      Populární tagy
    </h2>
    <div v-if="!isFetching" text-left gap-8px>
      <NuxtLink v-for="tag in allTags" :key="tag.slug" :to="tagLink(tag)">
        <BlogTag order-3 :tag="tag" :reverse="selected.includes(tag.slug)" />
      </NuxtLink>
    </div>
    <div v-else flex gap-8px>
      <USkeleton v-for="item in 3" :key="item" h-25px w-80px />
    </div>
  </div>
</template>
